// Duotone
import { faChartLine as fasChartLine } from '@fortawesome/pro-solid-svg-icons/faChartLine';
import { faGears as fadGears } from '@fortawesome/pro-duotone-svg-icons/faGears';
import { faBars as fadBars } from '@fortawesome/pro-duotone-svg-icons/faBars';
import { faCalendar as fadCalendar } from '@fortawesome/pro-duotone-svg-icons/faCalendar';
import { faCircleInfo as fadCircleInfo } from '@fortawesome/pro-duotone-svg-icons/faCircleInfo';
import { faIndustryWindows as fadIndustryWindows } from '@fortawesome/pro-duotone-svg-icons/faIndustryWindows';
import { faArrowLeft as fadArrowLeft } from '@fortawesome/pro-duotone-svg-icons/faArrowLeft';
import { faArrowRight as fadArrowRight } from '@fortawesome/pro-duotone-svg-icons/faArrowRight';
import { faRightFromBracket as fadRightFromBracket } from '@fortawesome/pro-duotone-svg-icons/faRightFromBracket';
import { faUser as fadUser } from '@fortawesome/pro-duotone-svg-icons/faUser';
import { faHouse as fadHouse } from '@fortawesome/pro-duotone-svg-icons/faHouse';
import { faNewspaper as fadNewspaper } from '@fortawesome/pro-duotone-svg-icons/faNewspaper';
import { faGrid2Plus as fadGrid2Plus } from '@fortawesome/pro-duotone-svg-icons/faGrid2Plus';
import { faFileInvoice as fadFileInvoice } from '@fortawesome/pro-duotone-svg-icons/faFileInvoice';
import { faGear as fadGear } from '@fortawesome/pro-duotone-svg-icons/faGear';
import { faChartLine as fadChartLine } from '@fortawesome/pro-duotone-svg-icons/faChartLine';
import { faUserTieHair as fadUserTieHair } from '@fortawesome/pro-duotone-svg-icons/faUserTieHair';
import { faRotate as fadRotate } from '@fortawesome/pro-duotone-svg-icons/faRotate';
import { faTable as fadTable } from '@fortawesome/pro-duotone-svg-icons/faTable';
import { faTimer as fadTimer } from '@fortawesome/pro-duotone-svg-icons/faTimer';
import { faPlus as farPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import { faSignature as fadSignature } from '@fortawesome/pro-duotone-svg-icons/faSignature';
import { faSpinnerThird as fadSpinnerThird } from '@fortawesome/pro-duotone-svg-icons/faSpinnerThird';
import { faInfo as fadInfo } from '@fortawesome/pro-duotone-svg-icons/faInfo';
import { faFilters as fadFilters } from '@fortawesome/pro-duotone-svg-icons/faFilters';
import { faFlaskGear as fadFlaskGear } from '@fortawesome/pro-duotone-svg-icons/faFlaskGear';
import { faEye as fadEye } from '@fortawesome/pro-duotone-svg-icons/faEye';
import { faCaretDown as fadCaretDown } from '@fortawesome/pro-duotone-svg-icons/faCaretDown';
import { faCaretUp as fadCaretUp } from '@fortawesome/pro-duotone-svg-icons/faCaretUp';
import { faLightEmergencyOn as fadLightEmergencyOn } from '@fortawesome/pro-duotone-svg-icons/faLightEmergencyOn';
import { faBuildingMagnifyingGlass as fadBuildingMagnifyingGlass } from '@fortawesome/pro-duotone-svg-icons/faBuildingMagnifyingGlass';
import { faPencil as fadPencil } from '@fortawesome/pro-duotone-svg-icons/faPencil';
import { faRepeat as fadRepeat } from '@fortawesome/pro-duotone-svg-icons/faRepeat';
import { faFileCertificate as fadFileCertificate } from '@fortawesome/pro-duotone-svg-icons/faFileCertificate';
import { faFileContract as fadFileContract } from '@fortawesome/pro-duotone-svg-icons/faFileContract';
import { faPenField as fadPenField } from '@fortawesome/pro-duotone-svg-icons/faPenField';
import { faPenLine as fadPenLine } from '@fortawesome/pro-duotone-svg-icons/faPenLine';
import { faListTimeline as fadListTimeline } from '@fortawesome/pro-duotone-svg-icons/faListTimeline';
import { faCloudArrowDown as fadCloudArrowDown } from '@fortawesome/pro-duotone-svg-icons/faCloudArrowDown';
import { faArrowDownToLine as fadArrowDownToLine } from '@fortawesome/pro-duotone-svg-icons/faArrowDownToLine';
import { faQuestion as fadQuestion } from '@fortawesome/pro-duotone-svg-icons/faQuestion';
import { faTriangleExclamation as fadTriangleExclamation } from '@fortawesome/pro-duotone-svg-icons/faTriangleExclamation';
import { faXmark as farXmark } from '@fortawesome/pro-duotone-svg-icons/faXmark';
import { faTrash as fadTrash } from '@fortawesome/pro-duotone-svg-icons/faTrash';
import { faInputNumeric as fadInputNumeric } from '@fortawesome/pro-duotone-svg-icons/faInputNumeric';
import { faMessage as fadMessage } from '@fortawesome/pro-duotone-svg-icons/faMessage';
import { faMobileScreen as fadMobileScreen } from '@fortawesome/pro-duotone-svg-icons/faMobileScreen';
import { faStopwatch as fadStopwatch } from '@fortawesome/pro-duotone-svg-icons/faStopwatch';
import { faClipboardList as fadClipboardList } from '@fortawesome/pro-duotone-svg-icons/faClipboardList';
import { faHourglassClock as fadHourglassClock } from '@fortawesome/pro-duotone-svg-icons/faHourglassClock';
import { faEllipsisVertical as fadEllipsisVertical } from '@fortawesome/pro-duotone-svg-icons/faEllipsisVertical';
import { faEllipsis as fadEllipsis } from '@fortawesome/pro-duotone-svg-icons/faEllipsis';
import { faMoneyCheckDollar as fadMoneyCheckDollar } from '@fortawesome/pro-duotone-svg-icons/faMoneyCheckDollar';
import { faLeftRight as fadLeftRight } from '@fortawesome/pro-duotone-svg-icons/faLeftRight';
import { faBuilding as fadBuilding } from '@fortawesome/pro-duotone-svg-icons/faBuilding';
import { faUserShield as fadUserShield } from '@fortawesome/pro-duotone-svg-icons/faUserShield';
import { faBan as fadBan } from '@fortawesome/pro-duotone-svg-icons/faBan';
import { faCheck as fadCheck } from '@fortawesome/pro-duotone-svg-icons/faCheck';
import { faDoorOpen as fadDoorOpen } from '@fortawesome/pro-duotone-svg-icons/faDoorOpen';
import { faCircleCheck as fadCircleCheck } from '@fortawesome/pro-duotone-svg-icons/faCircleCheck';
import { faCircleXmark as fadCircleXmark } from '@fortawesome/pro-duotone-svg-icons/faCircleXmark';

import FA from './fontawesome';
import { IconPacks } from './IconPacks';


/**
 * Pack used for the sunkhronos library
 */
export const webevolutionsPack = FA.createIconPack(
  IconPacks.Webevolutions,
  // #region Duotone
  fadCircleCheck,
  fadCircleXmark,
  fadBuilding,
  fadDoorOpen,
  fadBan,
  fadCheck,
  fadMoneyCheckDollar,
  fadLeftRight,
  fadHourglassClock,
  fadUserShield,
  fadEllipsisVertical,
  fadEllipsis,
  fadCircleInfo,
  fadTrash,
  fadMessage,
  fadSignature,
  fadIndustryWindows,
  fadInputNumeric,
  fadArrowLeft,
  fadStopwatch,
  fadArrowRight,
  fadClipboardList,
  fadCaretDown,
  fadFileInvoice,
  fadCaretUp,
  fadRightFromBracket,
  fadUser,
  fadHouse,
  fadNewspaper,
  fadGrid2Plus,
  fadMobileScreen,
  fadPenLine,
  fadGear,
  fadChartLine,
  fadUserTieHair,
  fadRotate,
  fadTable,
  fadCalendar,
  fadTimer,
  fadBars,
  fadSpinnerThird,
  fadInfo,
  fadFilters,
  fadFlaskGear,
  fadEye,
  fadBuildingMagnifyingGlass,
  fadGears,
  fadLightEmergencyOn,
  fadPencil,
  fadRepeat,
  fadFileCertificate,
  fadFileContract,
  fadPenField,
  fadListTimeline,
  fadCloudArrowDown,
  fadArrowDownToLine,
  fadQuestion,
  fadTriangleExclamation,
  // #endregion

  // #region Regular
  farPlus,
  farXmark,
  // #endregion

  // #region Solid
  fasChartLine,
  // #endregion
);